(ns dashboard.views.inference-job.detail.view
  (:require [re-frame.core :as rf]
            [dashboard.common :as common]
            [dashboard.views.inference-job.detail.events :as events]
            [dashboard.views.inference-job.detail.subs :as subs]))

(def -no-entries-notification :div.notification.is-primary.has-text-weight-bold)

(def controllers
  [{:parameters {:path [:questionnaire :job-name]}
    :start      (fn [{{:keys [questionnaire job-name]} :path}]
                  (rf/dispatch [::events/fetch-job-details questionnaire job-name])
                  (rf/dispatch [::events/fetch-policy-file-list])
                  (rf/dispatch [::events/fetch-questionnaire-file-details {:q-uuid questionnaire}]))}])


(defn title-with-loader [{:keys [title is-loading?]}]
  [:div.level>div.level-item.level-left
   [:p.title.is-4.mb-0 title]
   (when is-loading?
     [:div.loader.mx-3])])

(defn pipeline-component-parameter-row [[k v]]
  [:tr {:key k}
   [:td.has-text-weight-bold
    {:style {:border-bottom "1px solid transparent"}}
    (name k) ":"]
   [:td
    {:style {:border-bottom "1px solid transparent"}}
    v]])

(defn pipeline-component-row
  [component]
  [:tr {:key (:name component)}
   [:td (:name component)]
   [:td (:type component)]
   [:td.p-0 [:table.table>tbody
             (map pipeline-component-parameter-row (:params component))]]])

(defn policy-file-row [document-frequencies {:keys [created filename]}]
  [:tr {:key filename}
   [:td filename]
   [:td (get document-frequencies filename)]
   [:td.is-narrow  (common/format-date-time (js/Date. created))]])

(defn faq-row [row]
  [:tr {:key (:question row)}
   [:td(:question row)]
   [:td (or (:response row) (:answer row))]
   [:td (or (:comment row) (:additional-information row))]])

(defn view []
  (let [{:keys [faq-entries
                pipeline-components
                transform-job
                exception
                failed_questions
                document-frequencies
                document-store-download-link
                faq-download-link]}  @(rf/subscribe [::subs/details])
        questionnaire @(rf/subscribe [::subs/questionnaire-details])
        policy-files @(rf/subscribe [::subs/policy-files])
        filenames (set (keys document-frequencies))
        policies (filter (fn [{:keys [filename]}]
                           (contains?  filenames filename))
                         policy-files)
        {:keys [fetching-details?
                fetching-policy-files?
                fetching-questionnaire?]} @(rf/subscribe [::subs/loading-status])]

    [:div.section
     [:p.title.is-3 "Inference Job Detail"]
     [:div.section.mx-0.px-0
      [title-with-loader {:title       "SageMaker Batch Transform Job"
                          :is-loading? (and fetching-details?
                                            fetching-questionnaire?)}]

      (let [{:keys [CreationTime TransformJobStatus ModelName Duration]} transform-job
            minutes (js/Math.floor (/ Duration 1000 60))
            seconds (- (/ Duration 1000)
                       (* minutes 60))]
        ;; AWS SageMaker Transform Job Detail Table
        ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
        [:table.table.is-fullwidth
         [:thead.has-text-weight-bold
          [:tr
           [:td "Created"]
           [:td "Duration"]
           [:td "Questionnaire"]
           [:td "Status"]
           [:td "Model"]]]
         [:tbody
          [:tr
           [:td (.toDateString (js/Date. (js/Number. CreationTime)))]
           [:td (str minutes "m " seconds "s ")]
           [:td (or (:filename questionnaire)
                    (:custom-name questionnaire))]
           [:td TransformJobStatus]
           [:td ModelName]]]])]
     (when exception
       [:div.notification.is-danger.is-light
        "Inference Job was stopped early due: " (:message exception) " - " (:reason exception)])

     [:div.section.mx-0.px-0
      [title-with-loader {:title       "Failed questions"
                          :is-loading? fetching-details?}]
      (if-not (seq failed_questions)
        [:p "No failures, yay!"]
        [:table.table.is-fullwidth
         [:thead
          [:tr.has-text-weight-bold
           [:td "Question"]
           [:td "Exception"]]]
         [:tbody
          (for [{:keys [item-id content exception] :as _question} failed_questions]
            [:tr {:key item-id}
             [:td content]
             [:td exception]])]])]

     [:div.section.mx-0.px-0
      [title-with-loader {:title       "Haystack Pipeline components"
                          :is-loading? fetching-details?}]

      (if (empty? pipeline-components)
        [-no-entries-notification "No Entries"]
        ;; Haystack Pipeline Components Table
        ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
        [:table.table.is-fullwidth
         [:thead
          [:tr.has-text-weight-bold
           [:td "Name"]
           [:td "Type"]
           [:td "Parameters"]]]
         [:tbody
          (map pipeline-component-row pipeline-components)]])]
     [:div
      [:h3.title.is-3 "Haystack Document Store"]
      [:a {:href document-store-download-link} "Download raw contents"]
      [:div.section.mx-0.px-0
       [title-with-loader {:title       "Policy Documents"
                           :is-loading? (and  fetching-details?
                                              fetching-policy-files?)}]
       (if (empty? policies)
         [-no-entries-notification "No Entries"]
         [:table.table.is-fullwidth
          [:thead>tr.has-text-weight-bold
           [:td "Filename"]
           [:td "Haystack Documents"]
           [:td "Uploaded"]
           [:td ""]]
          [:tbody (map (partial policy-file-row document-frequencies) policies)]])]
      [:div.section.mx-0.px-0
       [title-with-loader {:title       "Answer Bank"
                           :is-loading? fetching-details?}]
       (when faq-download-link
         [:a {:href faq-download-link} "Download raw contents"])
       ;; FAQ entries table
      ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
       (if (empty? faq-entries)
         [-no-entries-notification "No Entries"]
         [:table.table.is-fullwidth
          [:thead.has-text-weight-bold
           [:tr
            [:td "Question"]
            [:td "Response"]
            [:td "Comment"]]]
          [:tbody
           (map faq-row faq-entries)]])]]]))
